module.exports = __webpack_public_path__ + "static/media/fire4.f5787dfe.svg";